import { PlanSize } from 'CommonData/poco/planSize';

export class LayingPattern {
    public id: number;
    public name: string;
    public swatchImageUrl: string;
    public planSizes: Array<PlanSize>;

    constructor({ id, name, swatchImageUrl, planSizes } : { id: number, name: string, swatchImageUrl?: string, planSizes?: Array<PlanSize> }) {
        this.id = id;
        this.name = name;
        this.swatchImageUrl = swatchImageUrl;
        this.planSizes = planSizes;
    }
}